import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';

export const API_DOMAIN: EndPointsNames = 'ApiFileEnvironment';
export const ENDPOINT_API_PATH = 'mfe-apps/check-env.txt';
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'NOT_CREDENTIALS';
const URL_POSTMAN = 'A definir';
export const CODE_ERRORS: ErrorResponseCodeType[] = [];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
};
